import React from "react";
import { connect } from "react-redux";
import { mapStateToPropsLogin } from "../../../modules/login";

const UserName = ({ userName, defaultValue = "" }) => {
  return <span className="user-name">{userName || defaultValue}</span>;
};

export default connect(mapStateToPropsLogin)(UserName);
